<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Materias promediables</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución 
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" @input="getCicloEscolar()" >
                                <!-- <template #message-danger >
                                    Requerido
                                </template> -->

                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                            <p v-if="errorInstituto == true" class="red"><strong> Campo Requerido </strong></p>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off">
                                <!-- <template #message-danger >
                                    Requerido
                                </template> -->

                                <template v-if="ciclosEscolares.length" autocomplete="off">
                                    <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                            <p v-if="errorCiclo == true" class="red"><strong> Campo Requerido </strong></p>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getMaterias()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <calculo-promedios :info="informacionGeneral" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getMaterias()"></calculo-promedios>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico.js'
import CalculoPromedios from './tabla-calculo-promedios.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            errorInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            errorCiclo: false,
            informacionGeneral: ''
        }
    },
    components:{
        CalculoPromedios
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.getCodigoDetalle()
                this.getFuenteMovimientosCargos()
            }
            catch{

            }
        },
        async getCicloEscolar() {
            const { data: response } = await academico.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
        },
        async getMaterias()  {
            try{
                const loading = this.$vs.loading()
                let params = {
                    'ciclo_escolar_id': this.cicloEscolar,
                    'institucion_id': this.institucion
                }
                const { data: response } = await academico.getMaterias(params)
                this.informacionGeneral = response
                loading.close()
            }catch{

            }
        },
    },
    watch:{
        instituto(){
            this.getCicloEscolar()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }
</style>